<template>
  <div class="login">
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Login',
  computed: {
    ...mapState(['appid', 'openid'])
  },
  created () {
    // 获取url中appid
    var url = decodeURIComponent(window.location.href)
    console.log(url)
    if (url.indexOf('?') !== -1) {
      var str = url.substr()
      var strs = str.split('?')
      for (var i = 0; i < strs.length; i++) {
        var theRequest = strs[i].split('=')[1]
      }
    }
    console.log(theRequest)
    // localStorage.setItem('appid', theRequest)
    if (theRequest !== this.appid) {
      this.changeArgs({villageId: 0, villageName: '请选择小区', permission: ''})
    }
    // 存放appid
    this.changeArgs({appid: theRequest})

    // 本地测试环境跳过授权，默认一个微信用户
    if (process.env.NODE_ENV === 'development') {
      this.changeArgs({openid: 'owHaPuE-RGtVQynVJqRcn5Q0kJB8', appid: 'wx9f37f2d6536da1fd', headPortrait: 'https://thirdwx.qlogo.cn/mmopen/vi_32/03ribcogXmnqNe1pX7dmXORytiajJDVf2oKiafergWR9AEUF2ouOKia52J0ia7sZQp0vxzZJoGUP8MACXBIvmh2rQ2Q/132', nickname: '李李'})
      this.$router.push({name: 'Index'})
    } else {
      this.axios.get('/wechat/index/getAuthorize/appid/' + this.appid)
        .then((res) => {
          if (res.data.status === 1) {
            window.location.replace(res.data.data)
          }
        })
    }
  },
  methods: {
    ...mapMutations(['changeArgs'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login/Login.vue